<template>
  <div class="pr-5 pl-5 pt-3 pb-8">
    <div class="pb-8" v-if="enableEvalCard">
      <EvaluateHomeCard />
    </div>

    <div v-if="itemHorizontal.length > 0">
      <template v-for="(item, idx) of itemHorizontal">
        <component
          class="my-2"
          :is="`${$componentIs(item.template)}`"
          :key="`el_${idx}`"
          :content="item"
        ></component>
      </template>
    </div>

    <!-- banner slide -->
    <!-- <v-carousel
      cycle
      height="300"
      hide-delimiter-background
      show-arrows-on-hover
      hide-delimiters
      class="slideShow"
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i" contain>
        <v-img :src="slide" contain></v-img>
      </v-carousel-item>
    </v-carousel> -->

    <!-- my course -->
    <!-- <v-row class="pt-10">
      <v-col cols="8">
        <div class="contentHeader">My Courses</div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <div class="contentHeader" align="right">
          <v-btn fab dark small elevation="0" color="#4a90e2">
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab dark small elevation="0" color="#4a90e2" class="ml-5">
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-row>
              <v-col cols="auto">
                <v-img
                  class="myCourseImage"
                  src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
                >
                </v-img>
              </v-col>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="py-2">
                  <v-progress-linear
                    value="85"
                    color="#afce8c"
                    height="10px"
                    class="customProgressbar"
                  ></v-progress-linear>
                </div>
                <div class="myCourseProcess">Process ( 85% )</div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-row>
              <v-col cols="auto">
                <v-img
                  class="myCourseImage"
                  src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
                >
                </v-img>
              </v-col>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="py-2">
                  <v-progress-linear
                    value="85"
                    color="#afce8c"
                    height="10px"
                    class="customProgressbar"
                  ></v-progress-linear>
                </div>
                <div class="myCourseProcess">Process ( 85% )</div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-row>
              <v-col cols="auto">
                <v-img
                  class="myCourseImage"
                  src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
                >
                </v-img>
              </v-col>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="py-2">
                  <v-progress-linear
                    value="85"
                    color="#afce8c"
                    height="10px"
                    class="customProgressbar"
                  ></v-progress-linear>
                </div>
                <div class="myCourseProcess">Process ( 85% )</div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
            style="height: 138px"
          >
            <v-row>
              <v-col>
                <div
                  align="center"
                  class="text-capitalize pt-10"
                  style="font-size: 16px; color: #4a90e2; font-weight: bold"
                >
                  See More >
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> -->

    <!-- recommended course -->
    <!-- <v-row class="pt-5">
      <v-col cols="9">
        <div class="contentHeader">Recommended Courses</div>
      </v-col>
      <v-col cols="3">
        <div class="contentHeader" align="right">
          <v-btn text class="mr-5" color="#4a90e2">
            <div class="text-capitalize" style="font-size: 16px">
              See More >
            </div>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> -->

    <!-- categories -->
    <!-- <v-row class="pt-5">
      <v-col cols="9">
        <div class="contentHeader">Categories</div>
      </v-col>
      <v-col cols="3">
        <div class="contentHeader" align="right">
          <v-btn text class="mr-5" color="#4a90e2">
            <div class="text-capitalize" style="font-size: 16px">
              See More >
            </div>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Categories</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> -->

    <!-- tags -->
    <!-- <v-row>
      <v-col cols="9">
        <div class="contentHeader">Tags</div>
      </v-col>
      <v-col cols="3">
        <div class="contentHeader" align="right">
          <v-btn text class="mr-5" color="#4a90e2">
            <div class="text-capitalize" style="font-size: 16px">
              See More >
            </div>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row class="pl-5">
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
      <v-btn class="mr-5">
        <v-icon>mdi-tag</v-icon>
        <div class="text-capitalize pl-2">Tag1</div>
      </v-btn>
    </v-row> -->

    <!-- instructiors -->
    <!-- <v-row class="pt-5">
      <v-col cols="9">
        <div class="contentHeader">Instructors</div>
      </v-col>
      <v-col cols="3">
        <div class="contentHeader" align="right">
          <v-btn text class="mr-5" color="#4a90e2">
            <div class="text-capitalize" style="font-size: 16px">
              See More >
            </div>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCustomCardNoBorder hoverable card-growable"
            elevation="0"
            ripple
          >
            <div align="center">
              <v-avatar size="62">
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" />
              </v-avatar>

              <div class="pt-3 myCustomLabel">Firstname Lastname</div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "@/event-bus";
import Dashboard from "../components/classroom/Dashboard.vue";
import DiscussionBoard from "./DiscussionBoard.vue";
import BannerSlider from "@/components/home_v2/NewBannerSlider.vue";
import MyCourseVerticalGridView from "@/components/home_v2/NewMyCourseVerticalGridView.vue";
import CourseVerticalGridView from "@/components/home_v2/NewCourseVerticalGridView.vue";
import CategoryHorizontalListView from "@/components/home_v2/NewCategoryHorizontalListView.vue";

// import BannerSlider from "@/components/BannerSlider.vue";
// import CategoryHorizontalListView from "@/components/CategoryHorizontalListView.vue";
// import CourseVerticalGridView from "@/components/CourseVerticalGridView.vue";
import GradeHorizontalListView from "@/components/GradeHorizontalListView.vue";
// import MyCourseVerticalGridView from "@/components/MyCourseVerticalGridView.vue";
import TagListView from "@/components/TagListView.vue";
import TeacherHorizontalListView from "@/components/TeacherHorizontalListView.vue";
import EvaluateHomeCard from "../components/evaluate/HomeCard";
import { checkCompany, formKey } from "../services/evaluateService";
export default {
  components: {
    Dashboard,
    DiscussionBoard,
    BannerSlider,
    MyCourseVerticalGridView,
    CourseVerticalGridView,
    CategoryHorizontalListView,
    GradeHorizontalListView,
    TagListView,
    TeacherHorizontalListView,
    EvaluateHomeCard,
  },
  data() {
    return {
      enableEvalCard: false,
      loading: false,
      showSkeleton: true,
      elements: null,
      itemHorizontal: [],
      horizontal: [
        "banner_slider",
        "my_course_vertical_gridview",
        "course_vertical_gridview",
        "category_horizontal_listview",
        "grade_horizontal_listview",
        "tag_list",
        "teacher_horizontal_listview",
      ],
      itemVertical: [],
      vertical: [
        "banner_slider",
        "my_course_vertical_gridview",
        "course_vertical_gridview",
        "category_horizontal_listview",
        "grade_horizontal_listview",
        "tag_list",
        "teacher_horizontal_listview",
      ],
    };
  },
  mounted() {
    this.init();
    let token = this.$cookies.get("user_token");
    if(token){
      checkCompany(formKey).then((val) => {
        this.enableEvalCard = val;
      });
    }
  },
  methods: {
    async init() {
      let token = this.$cookies.get("user_token");
      let company = Vue.prototype.$userInfo.companies[0]._id;
      let settings = Vue.prototype.$userInfo.setting;
      let item = settings.filter((item) => item.name == "Home");
      // this.itemHorizontal = Vue.prototype.$itemHorizontal;
      // this.itemVertical = Vue.prototype.$itemVertical;
      let dataVertical = [];
      // this.loading = true;
      this.$http
        .get(
          `${this.$store.state.api}/home/V2?index=${item[0].priority}${
            token ? "" : "&companyID=" + company
          }`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.elements = resp.data.result.elements;
            EventBus.$emit("updateNavBar", resp.data.result.navBarTitle);
            this.showSkeleton = false;
            this.itemHorizontal = this.elements.filter((item) =>
              this.horizontal.includes(item.template)
            );
            dataVertical = this.elements.filter((item) =>
              this.vertical.includes(item.template)
            );
            dataVertical.forEach((element) => {
              this.itemVertical[element.template] = element;
            });
            this.$emit("data", this.itemVertical);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.contentHeader {
  font-size: 26px;
  font-weight: bold;
  color: #000000;
}
</style>
